<template>
    <div class="applications-sorter">
        <form-select-group
            :label="$tc(`applicationsSorter.fieldLabel`)"
            :options="sorterSelectOptions"
            v-model="sortFieldName"
            @input="sort()"
        >
        </form-select-group>
    </div>
</template>

<script>
import {store, FormSelectGroup} from "atom";
const {createNamespacedHelpers} = store;
const {mapActions} = createNamespacedHelpers("arcman");
export default {
    name: "applications-sorter",
    components: {FormSelectGroup},
    props: {
        fields: {type: Array, required: true},
    },
    computed: {
        sorterSelectOptions() {
            return this.fields.map(item => ({text: this.$tc(`applicationsSorter.${item}`), value: item}));
        },
    },
    data() {
        return {
            sortFieldName: this.fields?.[0],
        };
    },
    methods: {
        ...mapActions({
            sortApplications: "SORT_APPLICATIONS",
            setApplicationsSortField: "SET_APPLICATIONS_SORT_FIELD",
        }),
        sort() {
            this.setApplicationsSortField(this.sortFieldName);
            this.sortApplications();
        },
    },
    mounted() {
        this.sort();
    },
};
</script>
